import { render, staticRenderFns } from "./CenterFitpay.vue?vue&type=template&id=6d8d7da8&"
import script from "./CenterFitpay.vue?vue&type=script&lang=js&"
export * from "./CenterFitpay.vue?vue&type=script&lang=js&"
import style0 from "./CenterFitpay.vue?vue&type=style&index=0&id=6d8d7da8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports